function createPillsSlider(sliderSelector) {
    try {
        BX.Sotbit.B2C.createSlider(sliderSelector, {
            slides: {
                perView: 'auto',
                spacing: 16
            },
            loop: false,
            arrows: true
        }, 'KeenSlider');
    } catch (error) {
        console.error(error);
    }
}
